import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-blocking-loader';
@customElement(tagName)
export class TmBlockingLoader extends TmBaseComponent {
    @property({ type: Boolean, reflect: true })
    public fullscreen = false;

    protected render(): unknown {
        return html` <span class="loader"></span> `;
    }

    public static get styles() {
        return css`
            :host {
                z-index: 30;
                position: fixed;
                background: var(--container-page, #666a66);
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                width: inherit;
                max-width: inherit;
            }
            .loader {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 48px;
                height: 48px;
                margin-top: -24px;
                margin-left: -24px;
                border: 5px solid #989898;
                border-bottom-color: transparent;
                border-radius: 50%;
                display: inline-block;
                box-sizing: border-box;
                animation: rotation 1s linear infinite;
            }

            :host([fullscreen]) {
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            @keyframes rotation {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmBlockingLoader;
    }
}
